var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarningRewardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    transform: "rotate(-180 21 21)",
    fill: "#49E400",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5373 23.6555C12.5373 23.4114 12.6272 23.1674 12.8199 22.9747C13.1924 22.6022 13.809 22.6022 14.1815 22.9747L21.2976 30.0908L28.4137 22.9747C28.7862 22.6022 29.4028 22.6022 29.7753 22.9747C30.1478 23.3472 30.1478 23.9638 29.7753 24.3363L21.9784 32.1332C21.6059 32.5057 20.9893 32.5057 20.6168 32.1332L12.8199 24.3363C12.6272 24.1436 12.5373 23.8995 12.5373 23.6555Z",
    fill: "#262832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 31.2339L20.333 9.61572C20.333 9.08907 20.7697 8.65234 21.2964 8.65234C21.823 8.65234 22.2598 9.08907 22.2598 9.61572L22.2598 31.2339C22.2598 31.7605 21.823 32.1973 21.2964 32.1973C20.7697 32.1973 20.333 31.7605 20.333 31.2339Z",
    fill: "#262832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningRewardIcon);
export default __webpack_public_path__ + "static/media/earning-reward-icon.0a3cbce07c2244ec8667097680f8eba6.svg";
export { ForwardRef as ReactComponent };